import { createSelector } from "reselect";
import { StoreState } from "../../models/states/StoreState";
import { isNullOrEmpty } from "../../utils";

export function makeMentionsSelector(variableName) {
    const mentionsByVariableNameSelector = (state: StoreState) =>
        state.interview.variables.mentionsByVariableName;

    const currentMatrixSelector = (state: StoreState) =>
        state.interview.navigation.currentPage.loopIndex;

    return createSelector(
        mentionsByVariableNameSelector,
        currentMatrixSelector,
        (mentionsByVariableName, matrix) => {
            const mentions = mentionsByVariableName[variableName] || [];
            return mentions.filter(
                (mention) => mention.matrix === matrix && !isNullOrEmpty(mention.value),
            );
        },
    );
}
